import { matchPath } from "react-router";
import { useLocation, Link } from "react-router-dom";
import { Box, useTheme } from "@mui/material";
import { useState , useEffect } from "react";

import darkLogo from './../../../assets/image/mini-logo-dark.png';
import lightLogo from './../../../assets/image/mini-logo-light-mode.png';
import { PlanMenu } from "./planMenu";
import { NewVideoMenu } from "./newVideoMenu";
import { SidebarMenuInfo, NewVideoInfo } from './../dashboard.config';
import kedyAiLogo from "../../../assets/image/home/kedy-mini.svg"
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import './dashboardHeader.scss';

import { GetProjectLink } from "../../../axios/ApiProvider";

export const EDIT_FRONTEND_URL = process.env.REACT_APP_BASE_FRONTEND_EDITOR_URL

const handleCreateNewProject = async () => {
  let result = await GetProjectLink();
  if (!result || result.state == 'error') window.toastr.error(result.data.message);
  else if (!!Object.keys(result.data)[0]) window.location.href = `${EDIT_FRONTEND_URL}/${Object.keys(result.data)[0]}?from=new`
}

export const DashboardNavbar = ({ userData }) => {
  const pathname = useLocation().pathname;
  const pathMatch = matchPath({ path: "/dashboard/:name", exact: true, strict: false }, pathname);
  const theme = useTheme();
  const [draweropen, setDraweropen] = useState(true);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  return (
    <Box className="dashboard-sidebar-contain">
      <section className="d-sidebar-section">
        <Box sx={{ 
          position: 'relative',
          display: 'flex', 
          alignItems: 'center', 

        }}>
          <Box className="d-sidebar-menu-icon mr-0" onClick={() => setDraweropen(!draweropen)} 
            sx={{ 
              display:'block',
              '@media (min-width:768px)': { display: 'none'},
              position : 'absolute',
              }}
               >
            {draweropen ? <CloseIcon sx={{ fontSize:30, ml:2}}/> : <MenuIcon sx={{ fontSize:30, ml:2}}/>}
          </Box>
          <Box className="d-logoImg">
            <Link to={'..'}>
              <img src={kedyAiLogo} alt='logoImg' style={{marginInline: "auto"}} />
            </Link>
          </Box>
        </Box>
        {/* <NewVideoMenu /> */}

        {((draweropen && screenWidth < 768)|| screenWidth >= 768) ?
        
        <Box className="d-sidebar-menu-items mobile-dashboard-animate">

          <Box className="">
            <PlanMenu userData={userData} />
          </Box>

          {NewVideoInfo.map((item, index) => {
            return (
              <Link to={item.link} key={index} style={{ color: 'white', backgroundColor: 'green' }}

                className={`d-sidebar-menu-item ${item.class}`} onClick={handleCreateNewProject}>
                <Box className="d-sidebar-menu-item-icon">{item.icon}</Box>
                {item.title}

                {item.badge.state && (
                  <Box className={`d-sidebar-menu-badge-icon ${item.badge.class}`}>
                    {item.badge.icon}
                  </Box>
                )}
              </Link>
            )
          })}

          {SidebarMenuInfo.map((item, index) => {
            return (
              <Link to={item.link} key={index} onClick={() => setTimeout(()=>setDraweropen(false), 100)}
                className={`d-sidebar-menu-item ${item.class} ${!pathMatch ? index === 0 ? 'active' : '' : pathMatch.params.name === item.link ? 'active' : ''}`}>
                <Box className="d-sidebar-menu-item-icon">{item.icon}</Box>
                {item.title}

                {item.badge.state && (
                  <Box className={`d-sidebar-menu-badge-icon ${item.badge.class}`}>
                    {item.badge.icon}
                  </Box>
                )}
              </Link>
            )
          })}
        </Box> :<></>}
      </section>
    </Box>
  )
}